// A menu section as the back office shows it (Oct 2026, Chris's review M5). A section is the
// `category` its dishes carry: what an owner named it ("Beer & cider", "BBQ"), shown as
// they typed it; or a key from an older menu or the demo ("soft_drinks"), which the till has
// always shown as words. Only a key changes: "soft_drinks" reads "Soft drinks".
export function sectionName(name) {
  const s = String(name || '');
  return /^[a-z][a-z0-9_]*$/.test(s) ? (s.charAt(0).toUpperCase() + s.slice(1)).replace(/_/g, ' ') : s;
}
